/**
 * @author Teresa Ocampo
 * @company Erillam Healthcare
 * @version 1.0
 */

 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";

 export default class PatientFileRequest extends MainRequest{

   static listAll() {
   }
   static add(object) {
      return this.postFILESEC(ServicePath.PATIENT_FILE_ADD, object);
   }
   static uploadFilesInterpretation(object) {
      return this.postFILESEC(ServicePath.PATIENT_FILE_ADD_INTERPRETATION, object);
   }

   static findAddendumsByPatient(object){
      return this.postSEC(ServicePath.PATIENT_FILE_FIND_BY_PATIENT, object);
   }
   static addFilesScanned(object){
      return this.postSEC(ServicePath.PATIENT_SCANNED_ADD, object);
   }

   static findOneAddendumByPatient(object){
      return this.postSEC(ServicePath.PATIENT_FILE_FIND_ONE_BY_PATIENT, object);
   }

   static deleteFileByPatient(object){
      return this.postSEC(ServicePath.PATIENT_FILE_DELETE_ONE_BY_PATIENT, object);
   }

   static addScannerFiles(object){
      return this.postSEC(ServicePath.PATIENT_ADD_SCANNER_DOCUMENT, object);
   }

 }